.page-component {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 69px - 2rem);
  box-sizing: border-box;
}
.page-component > .bound-error {
  height: 90vh;
}
.page-component .dock-tools {
  position: fixed;
  display: flex;
  justify-content: center;
  width: 100px;
  bottom: 3%;
  left: 50%;
  margin-left: -50px;
}
.page-component .dock-tools div {
  background-color: white;
  display: flex;
  box-shadow: 1px 3px 10px 0 rgba(0, 0, 0, 0.5);
  padding: 0.25rem;
  border-radius: 5px;
}
.page-component .dock-tools button {
  font-weight: 300;
  background-color: white !important;
  color: black !important;
  margin-left: 5px;
  box-shadow: none;
}
.page-component .dock-tools button.active {
  box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.6) !important;
}
.page-component .dock-tools button:hover {
  border: 1px solid #3366ff;
  color: #3366ff !important;
}

.draggable-container {
  position: fixed;
  width: calc(100% - 0.9rem);
  height: calc(100% - 0.9rem);
  padding-top: 65px;
  padding-left: 5rem;
}

.page-component-error {
  margin-top: 65px;
  padding: 1rem;
}

.page-loader {
  z-index: 1001;
  top: 70px;
}
.page-loader .loader,
.page-loader .loader-text {
  transform: translateY(calc(50% - 30px));
}

.public {
  margin-top: 1rem;
}

.private {
  margin-top: 0.5rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9zcmMvc2NyaXB0L2NvbXBvbmVudHMvUGFnZSIsInNvdXJjZXMiOlsiUGFnZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUVBO0VBQ0E7O0FBRUE7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFFRjtFQUNFO0VBQ0E7OztBQU1SO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7O0FBRUE7QUFBQTtFQUVFOzs7QUFJSjtFQUNFOzs7QUFFRjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLnBhZ2UtY29tcG9uZW50IHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgLy8gMTAwdmggLSBoZWFkZXIgLSBwYW5lbCBtYXJnaW5zXG4gIG1pbi1oZWlnaHQ6IGNhbGMoMTAwdmggLSA2OXB4IC0gMnJlbSk7XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG5cbiAgPiAuYm91bmQtZXJyb3Ige1xuICAgIGhlaWdodDogOTB2aDtcbiAgfVxuXG4gIC5kb2NrLXRvb2xzIHtcbiAgICBwb3NpdGlvbjogZml4ZWQ7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICB3aWR0aDogMTAwcHg7XG4gICAgYm90dG9tOiAzJTtcbiAgICBsZWZ0OiA1MCU7XG4gICAgbWFyZ2luLWxlZnQ6IC01MHB4O1xuICAgIGRpdiB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiB3aGl0ZTtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBib3gtc2hhZG93OiAxcHggM3B4IDEwcHggMCByZ2JhKDAsIDAsIDAsIDAuNSk7XG4gICAgICBwYWRkaW5nOiAwLjI1cmVtO1xuICAgICAgYm9yZGVyLXJhZGl1czogNXB4O1xuICAgIH1cbiAgICBidXR0b24ge1xuICAgICAgZm9udC13ZWlnaHQ6IDMwMDtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6IHdoaXRlICFpbXBvcnRhbnQ7XG4gICAgICBjb2xvcjogYmxhY2sgIWltcG9ydGFudDtcbiAgICAgIG1hcmdpbi1sZWZ0OiA1cHg7XG4gICAgICBib3gtc2hhZG93OiBub25lO1xuXG4gICAgICAmLmFjdGl2ZSB7XG4gICAgICAgIGJveC1zaGFkb3c6IGluc2V0IDAgMXB4IDFweCAwIHJnYmEoMCwgMCwgMCwgMC42KSAhaW1wb3J0YW50O1xuICAgICAgfVxuICAgICAgJjpob3ZlciB7XG4gICAgICAgIGJvcmRlcjogMXB4IHNvbGlkICMzMzY2ZmY7XG4gICAgICAgIGNvbG9yOiAjMzM2NmZmICFpbXBvcnRhbnQ7XG4gICAgICB9XG4gICAgfVxuICB9XG59XG5cbi5kcmFnZ2FibGUtY29udGFpbmVyIHtcbiAgcG9zaXRpb246IGZpeGVkO1xuICB3aWR0aDogY2FsYygxMDAlIC0gMC45cmVtKTtcbiAgaGVpZ2h0OiBjYWxjKDEwMCUgLSAwLjlyZW0pO1xuICBwYWRkaW5nLXRvcDogNjVweDtcbiAgcGFkZGluZy1sZWZ0OiA1cmVtO1xufVxuXG4ucGFnZS1jb21wb25lbnQtZXJyb3Ige1xuICBtYXJnaW4tdG9wOiA2NXB4O1xuICBwYWRkaW5nOiAxcmVtO1xufVxuXG4ucGFnZS1sb2FkZXIge1xuICB6LWluZGV4OiAxMDAxO1xuICB0b3A6IDcwcHg7XG5cbiAgLmxvYWRlcixcbiAgLmxvYWRlci10ZXh0IHtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoY2FsYyg1MCUgLSAzMHB4KSk7XG4gIH1cbn1cblxuLnB1YmxpYyB7XG4gIG1hcmdpbi10b3A6IDFyZW07XG59XG4ucHJpdmF0ZSB7XG4gIG1hcmdpbi10b3A6IDAuNXJlbTtcbn1cbiJdfQ== */